import { render, staticRenderFns } from "./KanbanAtrasados.vue?vue&type=template&id=30239fa0&scoped=true&"
import script from "./KanbanAtrasados.vue?vue&type=script&lang=js&"
export * from "./KanbanAtrasados.vue?vue&type=script&lang=js&"
import style0 from "./KanbanAtrasados.vue?vue&type=style&index=0&id=30239fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30239fa0",
  null
  
)

export default component.exports